import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';


export default {
    saveRegularOperationEntity,
    editData,
    getGroups,
    getRegularOperationEntityByGroupID,
    getRegularOperationEntityByID,
    getEntityTypes
};

async function saveRegularOperationEntity(data){
    let company = {
        operationEntityCode: data.operationEntityCode,
        operationEntityName: data.operationEntityName.trim(),
        operationEntityLocation: data.operationEntityLocation.trim(),
        groupID: parseInt(data.groupID),
        enityTypeID: parseInt(data.enityTypeID),
        isErpEnabled: data.isErpEnabled,
        isActive: data.isActive,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/OperationEntity/SaveRegularOperationEntity', null, company);
    return response;
}

async function editData(data) {
    let company = {
        operationEntityID : data.operationEntityID,
        operationEntityCode: data.operationEntityCode,
        operationEntityName: data.operationEntityName.trim(),
        operationEntityLocation: data.operationEntityLocation.trim(),
        groupID: parseInt(data.groupID),
        enityTypeID: parseInt(data.enityTypeID),
        isErpEnabled: data.isErpEnabled,
        isActive: data.isActive,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString()
    }
    const response = await CommonPost('/api/OperationEntity/UpdateeRegularOperationEntity', null, company); 
    return response;
    
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function getRegularOperationEntityByGroupID(groupID){
    const response = await CommonGet('/api/OperationEntity/GetRegularOperationEntityByGroupID', 'groupID=' + groupID);
    return response;
}

async function getRegularOperationEntityByID(id) {
    const response = await CommonGet('/api/OperationEntity/GetRegularOperationEntityByID', 'id=' + id);
    return response.data;
}

async function getEntityTypes() {
    var entityTypeArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEntities', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            entityTypeArray[item[1]["entityTypeID"]] = item[1]["entityTypeName"];
        }
    }
    return entityTypeArray;
}